import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.fabbench');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-fabbench',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.fabbench/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.benchmark-page {
  min-height: 100vh;
  background: radial-gradient(circle at 90% 0, rgba(139, 92, 246, 0.09), transparent 26rem), #f8fafc;
}

.progress-fill {
  transition: width 220ms ease;
}

.result-row {
  transition: background-color 140ms ease;
}

.result-row:hover {
  background: #f8fafc;
}

.truncate-answer {
  max-width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media (max-width: 767px) {
  .details-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}`],
})
export class PageFabbenchComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public judgeModeOptions: any[] = [
        { value: 'LOCAL', label: 'Local Judge', description: '기존 Qwen/Ollama 채점' },
        { value: 'OPENAI', label: 'OpenAI Judge', description: 'GPT Structured Output 채점' },
        { value: 'COMPARE', label: '신규 답변 Judge 비교', description: '선택 모델 생성 후 Local·OpenAI 비교' },
        { value: 'RECOMPARE', label: '저장 답변 공정 재평가', description: 'Generator 0회 · Appendix E rubric 비교' }
    ];
    public scopeOptions: any[] = [
        { value: 'TEST_5', label: '우선 5문항 테스트', limit: 5 },
        { value: 'FULL', label: '전체 SUBJECTIVE 평가', limit: 0 }
    ];
    public categoryOptions: any[] = [
        { value: 'ALL', label: '전체 SUBJECTIVE', description: 'ROB · MULTI · GEN' },
        { value: 'ROB', label: 'ROB', description: 'Retrieval Robustness' },
        { value: 'MULTI', label: 'MULTI', description: 'Multi-hop Retrieval' },
        { value: 'GEN', label: 'GEN', description: 'Generation Quality' }
    ];
    public filterOptions: any[] = [
        { value: 'ALL', label: '전체' },
        { value: 'SCORED', label: '채점 완료' },
        { value: 'ERRORS', label: '오류 전체' },
        { value: 'API_ERRORS', label: 'API 오류' },
        { value: 'JUDGE_JSON_ERROR', label: 'Judge JSON 오류' }
    ];
    public metricCatalog: any[] = [
        { key: 'factuality', label: 'Factuality', description: '사실 정확성' },
        { key: 'completeness', label: 'Completeness', description: '핵심 내용 충실도' },
        { key: 'technical_depth', label: 'Technical Depth', description: '기술적 깊이' },
        { key: 'relevance', label: 'Relevance', description: '질문 관련성' },
        { key: 'context_utilization', label: 'Context Utilization', description: 'gold context 통합 활용도' },
        { key: 'support_quality', label: 'Support Quality', description: '구체적 근거와 예시의 품질' }
    ];
    public metrics: any[] = this.metricCatalog.slice();
    public selectedCategory: string = 'ALL';
    public selectedGeneratorModel: string = 'gemma4:26b-a4b-it-q8_0';
    public selectedJudgeModel: string = '';
    public selectedJudgeMode: string = 'RECOMPARE';
    public evaluationScope: string = 'TEST_5';
    public resultFilter: string = 'ALL';
    public scoringVersion: string = 'subjective-local-judge-shared-rubric-v6';
    public runKind: string = 'subjective_local_judge';
    public benchmark: any = {
        available: false,
        counts: {},
        total_subjective: 0,
        generator_model: 'gemma4:26b-a4b-it-q8_0',
        execution_server: {},
        generator_temperature: 0,
        judge_temperature: 0,
        judge_json_max_retries: 3,
        judge_api_max_retries: 3,
        ollama_keep_alive: 0,
        judge_gpu_num_ctx: 4096,
        judge_cpu_num_ctx: 16384,
        judge_model_fallback_enabled: false,
        score_min: 0,
        score_max: 10,
        normalization_divisor: 10,
        normalized_min: 0,
        normalized_max: 1,
        rag_enabled: false,
        external_api_enabled: true,
        default_openai_test_limit: 5,
        openai_judge: {
            model: '',
            api_key_configured: false,
            temperature: 0,
            structured_output: true,
            stream: false,
            store: false
        },
        stream: false
    };
    public ollamaModels: any[] = [];
    public generatorModels: any[] = [];
    public cases: any[] = [];
    public results: any[] = [];
    public comparisonResults: any[] = [];
    public summary: any = this.emptySummary();
    public comparisonSummary: any = this.emptyComparisonSummary();
    public loading: boolean = true;
    public modelsLoading: boolean = false;
    public running: boolean = false;
    public cancelRequested: boolean = false;
    public activeCase: any = null;
    public selectedResult: any = null;
    public error: string = '';
    public modelError: string = '';
    public notice: string = '';
    public savedFiles: any[] = [];
    public runStartedAt: string = '';
    public runCompletedAt: string = '';
    public evaluationRunId: string = '';
    public resumeAfterTestId: string = '';
    public paused: boolean = false;
    public failedCase: any = null;
    public networkRetryCount: number = 0;
    public mergeSegments: any[] = [];
    public mergeFiles: any[] = [];
    public mergeRunning: boolean = false;
    public mergeError: string = '';
    public mergeResult: any = null;
    public mergedDocument: any = null;
    public savedSubjectiveRuns: any[] = [];
    public selectedSourceRunId: string = '';
    public sourceRunError: string = '';
    public historyRuns: any[] = [];
    public selectedHistoryRunId: string = '';
    public historyLoading: boolean = false;
    public historyError: string = '';
    public loadedHistory: any = null;
    public loadedHistoryDocument: any = null;
    public scoreMaximum: number = 10;

    public async ngOnInit() {
        await this.service.init();
        await this.loadModels();
        await this.loadBenchmark();
        await this.loadSavedSubjectiveRuns();
        await this.loadSubjectiveHistory();
    }

    public async loadModels(force: boolean = false) {
        if (this.running) return;
        this.modelsLoading = true;
        this.modelError = '';
        await this.service.render();
        const response: any = await wiz.call('ollama_models', {
            force: force ? 'true' : 'false'
        });
        if (response && response.code === 200) {
            this.ollamaModels = response.data.models || [];
            const reportedGeneratorModels = response.data.generator_models || [];
            this.generatorModels = reportedGeneratorModels.length
                ? reportedGeneratorModels
                : this.generatorModelsFromLegacyResponse(this.ollamaModels);
            const availableGenerators = this.generatorModels.filter(
                (item: any) => item.available
            );
            const generatorExists = availableGenerators.some(
                (item: any) => item.name === this.selectedGeneratorModel
            );
            if (!generatorExists) {
                this.selectedGeneratorModel = response.data.default_generator_model
                    || (availableGenerators[0] && availableGenerators[0].name)
                    || '';
            }
            const selectable = this.ollamaModels.filter((item: any) => item.available_for_judge);
            const selectedExists = selectable.some(
                (item: any) => item.name === this.selectedJudgeModel
                    && item.name !== this.selectedGeneratorModel
            );
            if (!selectedExists) {
                this.selectedJudgeModel = (
                    selectable.find((item: any) => item.name !== this.selectedGeneratorModel)
                    || {}
                ).name || '';
            }
            if (!this.selectedGeneratorModel) {
                this.modelError = '사용 가능한 SUBJECTIVE 답변 생성 모델이 없습니다.';
            } else if (!this.selectedJudgeModel) {
                this.modelError = '답변 생성 모델과 다른 Ollama Judge 모델이 필요합니다.';
            }
        } else {
            this.ollamaModels = [];
            this.generatorModels = [];
            this.selectedGeneratorModel = '';
            this.selectedJudgeModel = '';
            this.modelError = this.errorMessage(response, 'Ollama 모델 목록을 불러오지 못했습니다.');
        }
        this.modelsLoading = false;
        await this.service.render();
    }

    public generatorModelsFromLegacyResponse(models: any[]) {
        const configured = [
            {
                name: 'gemma4:26b-a4b-it-q8_0',
                label: 'Gemma4 26B',
                description: '기존 OBJECTIVE 기준 모델 · 25.8B · Q8_0'
            },
            {
                name: 'qwen3.8:27b',
                label: 'Qwen 3.8 27B',
                description: 'Ollama 실조회 모델 · 27.3B · Q4_K_M'
            }
        ];
        return configured.map((item: any) => {
            const actual = (models || []).find(
                (model: any) => model.name === item.name
            ) || {};
            return {
                ...item,
                available: !!actual.is_local && !actual.is_embedding,
                size: Number(actual.size || 0),
                family: actual.family || '',
                parameter_size: actual.parameter_size || '',
                quantization_level: actual.quantization_level || ''
            };
        });
    }

    public async loadBenchmark() {
        if (this.running) return;
        this.loading = true;
        this.error = '';
        this.notice = '';
        await this.service.render();
        const categories = this.selectedCategory === 'ALL' ? [] : [this.selectedCategory];
        const response: any = await wiz.call('subjective_benchmark', {
            categories: JSON.stringify(categories)
        });
        if (response && response.code === 200) {
            this.benchmark = response.data.benchmark || this.benchmark;
            this.cases = response.data.cases || [];
            this.scoringVersion = this.benchmark.scoring_version || this.scoringVersion;
            this.runKind = this.benchmark.run_kind || this.runKind;
            this.scoreMaximum = Number(this.benchmark.score_max || 10);
        } else {
            this.cases = [];
            if (response && response.data && response.data.benchmark) {
                this.benchmark = response.data.benchmark;
            }
            this.error = this.errorMessage(response, 'FAB-Bench SUBJECTIVE 데이터셋을 불러오지 못했습니다.');
        }
        this.resetRun();
        this.loading = false;
        await this.service.render();
    }

    public async changeCategory() {
        this.resumeAfterTestId = '';
        await this.loadBenchmark();
    }

    public changeJudgeMode() {
        this.resetRun();
        this.error = '';
        this.notice = '';
    }

    public changeGeneratorModel() {
        if (this.selectedJudgeModel === this.selectedGeneratorModel) {
            this.selectedJudgeModel = (
                this.ollamaModels.find(
                    (model: any) => model.available_for_judge
                        && model.name !== this.selectedGeneratorModel
                ) || {}
            ).name || '';
        }
        this.modelError = this.selectedGeneratorModel && !this.selectedJudgeModel
            ? '답변 생성 모델과 다른 Ollama Judge 모델이 필요합니다.'
            : '';
        this.resetRun();
        this.error = '';
        this.notice = '';
    }

    public async loadSavedSubjectiveRuns() {
        this.sourceRunError = '';
        const response: any = await wiz.call('subjective_saved_runs', {});
        if (response && response.code === 200) {
            this.savedSubjectiveRuns = response.data.runs || [];
            const selectedExists = this.savedSubjectiveRuns.some(
                (run: any) => run.run_id === this.selectedSourceRunId
            );
            if (!selectedExists) {
                const complete = this.savedSubjectiveRuns.find(
                    (run: any) => run.reusable_answer_count === this.benchmark.total_subjective
                );
                this.selectedSourceRunId = (complete || this.savedSubjectiveRuns[0] || {}).run_id || '';
            }
            const sourceModel = String(this.sourceRun().judge_model || '');
            if (sourceModel && this.ollamaModels.some(
                (model: any) => model.name === sourceModel
                    && model.available_for_judge
                    && model.name !== this.effectiveGeneratorModel()
            )) {
                this.selectedJudgeModel = sourceModel;
            }
        } else {
            this.savedSubjectiveRuns = [];
            this.selectedSourceRunId = '';
            this.sourceRunError = this.errorMessage(
                response,
                '저장된 SUBJECTIVE 답변 목록을 불러오지 못했습니다.'
            );
        }
        await this.service.render();
    }

    public sourceRun() {
        return this.savedSubjectiveRuns.find(
            (run: any) => run.run_id === this.selectedSourceRunId
        ) || {};
    }

    public async loadSubjectiveHistory() {
        if (this.running) return;
        this.historyLoading = true;
        this.historyError = '';
        await this.service.render();
        const response: any = await wiz.call('subjective_history', {});
        if (response && response.code === 200) {
            this.historyRuns = response.data.runs || [];
            if (!this.historyRuns.some(
                (run: any) => run.run_id === this.selectedHistoryRunId
            )) {
                this.selectedHistoryRunId = (this.historyRuns[0] || {}).run_id || '';
            }
        } else {
            this.historyRuns = [];
            this.selectedHistoryRunId = '';
            this.historyError = this.errorMessage(
                response,
                '저장된 SUBJECTIVE 평가 이력을 불러오지 못했습니다.'
            );
        }
        this.historyLoading = false;
        await this.service.render();
    }

    public selectedHistoryRun() {
        return this.historyRuns.find(
            (run: any) => run.run_id === this.selectedHistoryRunId
        ) || {};
    }

    public async openHistoryRun() {
        if (this.running || !this.selectedHistoryRunId) return;
        this.historyLoading = true;
        this.historyError = '';
        await this.service.render();
        const response: any = await wiz.call('subjective_history_detail', {
            run_id: this.selectedHistoryRunId
        });
        if (!(response && response.code === 200 && response.data.document)) {
            this.historyError = this.errorMessage(
                response,
                '선택한 SUBJECTIVE 평가 이력을 불러오지 못했습니다.'
            );
            this.historyLoading = false;
            await this.service.render();
            return;
        }
        const document = response.data.document;
        const history = document.history || this.selectedHistoryRun();
        const execution = document.execution || {};
        this.resetRun();
        this.loadedHistory = history;
        this.loadedHistoryDocument = document;
        this.scoreMaximum = Number(history.score_max || execution.score_max || 10);
        const metricKeys = Array.isArray(history.judge_metrics)
            ? history.judge_metrics
            : [];
        this.metrics = this.metricCatalog.filter(
            (metric: any) => !metricKeys.length || metricKeys.indexOf(metric.key) >= 0
        );
        this.selectedJudgeMode = history.judge_mode === 'COMPARE'
            ? 'COMPARE'
            : history.judge_mode;
        this.scoringVersion = document.scoring_version || this.scoringVersion;
        this.runKind = document.run_kind || this.runKind;
        this.selectedGeneratorModel = execution.generator_model || this.selectedGeneratorModel;
        this.runStartedAt = execution.started_at || document.generated_at || '';
        this.runCompletedAt = execution.completed_at || document.generated_at || '';
        const rows = Array.isArray(document.results) ? document.results : [];
        if (history.judge_mode === 'COMPARE') {
            this.comparisonResults = rows.map((row: any) => {
                const hydrated = Object.assign({}, row);
                hydrated.local_judge = this.hydrateHistoryJudge(row.local_judge || {});
                hydrated.openai_judge = this.hydrateHistoryJudge(row.openai_judge || {});
                hydrated.score_differences_normalized = Object.assign(
                    {},
                    row.score_differences_normalized || {}
                );
                for (const metric of this.metrics) {
                    const raw = (row.score_differences || {})[metric.key];
                    if (this.isNumeric(raw)
                        && !this.isNumeric(hydrated.score_differences_normalized[metric.key])) {
                        hydrated.score_differences_normalized[metric.key] = Number(raw)
                            / this.scoreMaximum;
                    }
                }
                if (this.isNumeric(row.overall_difference)
                    && !this.isNumeric(row.overall_difference_normalized)) {
                    hydrated.overall_difference_normalized = Number(row.overall_difference)
                        / this.scoreMaximum;
                }
                return hydrated;
            });
        } else {
            this.results = rows.map((row: any) => this.hydrateHistoryJudge(row));
        }
        this.evaluationScope = rows.length > 5 ? 'FULL' : 'TEST_5';
        this.recalculateSummary();
        this.notice = (
            this.formatDate(document.generated_at) + ' 저장 이력 '
            + rows.length + '건을 읽기 전용으로 불러왔습니다.'
        );
        this.historyLoading = false;
        await this.service.render();
    }

    public downloadLoadedHistory() {
        if (!this.loadedHistoryDocument) return;
        const original = JSON.parse(JSON.stringify(this.loadedHistoryDocument));
        delete original.history;
        const blob = new Blob(
            [JSON.stringify(original, null, 2)],
            { type: 'application/json;charset=utf-8' }
        );
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = this.loadedHistory.run_id + '.json';
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    }

    public effectiveGeneratorModel() {
        return this.isSavedReevaluationMode()
            ? String(this.sourceRun().generator_model || this.selectedGeneratorModel || '')
            : this.selectedGeneratorModel;
    }

    public sourceRunIsComplete() {
        return Number(this.sourceRun().reusable_answer_count || 0)
            === Number(this.benchmark.total_subjective || 0);
    }

    public changeSourceRun() {
        const sourceModel = String(this.sourceRun().judge_model || '');
        if (sourceModel && this.ollamaModels.some(
            (model: any) => model.name === sourceModel
                && model.available_for_judge
                && model.name !== this.effectiveGeneratorModel()
        )) {
            this.selectedJudgeModel = sourceModel;
        } else if (this.selectedJudgeModel === this.effectiveGeneratorModel()) {
            this.selectedJudgeModel = (
                this.ollamaModels.find(
                    (model: any) => model.available_for_judge
                        && model.name !== this.effectiveGeneratorModel()
                ) || {}
            ).name || '';
        }
        this.changeScope();
    }

    public isComparisonMode() {
        return this.selectedJudgeMode === 'COMPARE' || this.selectedJudgeMode === 'RECOMPARE';
    }

    public isSavedReevaluationMode() {
        return this.selectedJudgeMode === 'RECOMPARE';
    }

    public changeScope() {
        this.resumeAfterTestId = '';
        this.resetRun();
    }

    public changeResumePoint() {
        const resumeIndex = this.cases.findIndex(
            (item: any) => item.test_id === this.resumeAfterTestId
        );
        if (resumeIndex >= 5) this.evaluationScope = 'FULL';
        this.resetRun();
    }

    public usesLocalJudge() {
        return this.selectedJudgeMode === 'LOCAL' || this.isComparisonMode();
    }

    public usesOpenAIJudge() {
        return this.selectedJudgeMode === 'OPENAI' || this.isComparisonMode();
    }

    public openAIConfig() {
        return this.benchmark.openai_judge || {};
    }

    public canStart() {
        if (this.loading || this.modelsLoading || this.running) return false;
        if (!this.benchmark.available || !this.runCases().length) return false;
        if (!this.isSavedReevaluationMode() && !this.selectedGeneratorModel) return false;
        if (this.usesLocalJudge() && (
            !this.selectedJudgeModel || this.selectedJudgeModel === this.effectiveGeneratorModel()
        )) return false;
        if (this.usesOpenAIJudge() && !this.openAIConfig().api_key_configured) return false;
        if (this.isSavedReevaluationMode() && !this.selectedSourceRunId) return false;
        if (this.isSavedReevaluationMode()
            && this.evaluationScope === 'FULL'
            && !this.sourceRunIsComplete()) return false;
        return true;
    }

    public runCases() {
        const sourceIds = new Set(
            this.isSavedReevaluationMode() ? (this.sourceRun().test_ids || []) : []
        );
        const available = this.isSavedReevaluationMode()
            ? this.cases.filter((item: any) => sourceIds.has(item.test_id))
            : this.cases.slice();
        const scoped = this.evaluationScope === 'TEST_5'
            ? available.slice(0, 5)
            : available;
        if (!this.resumeAfterTestId) return scoped;
        const completedIndex = scoped.findIndex(
            (item: any) => item.test_id === this.resumeAfterTestId
        );
        return completedIndex >= 0 ? scoped.slice(completedIndex + 1) : scoped;
    }

    public canResume() {
        return this.paused && !this.running && !!this.failedCase && this.canStart();
    }

    public resultCount() {
        return this.isComparisonMode()
            ? this.comparisonResults.length
            : this.results.length;
    }

    public async startEvaluation() {
        if (!this.canStart()) return;

        this.resetRun();
        this.evaluationRunId = this.newEvaluationRunId();
        this.error = '';
        this.notice = '';
        this.cancelRequested = false;
        this.runStartedAt = new Date().toISOString();
        await this.runPendingEvaluation();
    }

    public async resumeEvaluation() {
        if (!this.canResume()) return;
        this.paused = false;
        this.failedCase = null;
        this.error = '';
        this.notice = '중단된 문항부터 평가를 재개합니다.';
        await this.runPendingEvaluation();
    }

    private async runPendingEvaluation() {
        this.running = true;
        this.cancelRequested = false;
        await this.service.render();

        for (const item of this.pendingCases()) {
            if (this.cancelRequested) break;
            this.activeCase = item;
            await this.service.render();
            const requestStartedAt = Date.now();
            const endpoint = this.selectedJudgeMode === 'LOCAL'
                ? 'evaluate_subjective'
                : (this.selectedJudgeMode === 'OPENAI'
                    ? 'evaluate_subjective_openai'
                    : (this.isSavedReevaluationMode()
                        ? 'reevaluate_subjective_saved_comparison'
                        : 'evaluate_subjective_comparison'));
            const params: any = { test_id: item.test_id };
            if (!this.isSavedReevaluationMode()) {
                params.generator_model = this.selectedGeneratorModel;
            }
            if (this.usesLocalJudge()) params.judge_model = this.selectedJudgeModel;
            if (this.isSavedReevaluationMode()) {
                params.source_run_id = this.selectedSourceRunId;
            }
            params.request_token = this.requestToken(item);
            let response: any;
            try {
                response = await this.callWithNetworkRetry(endpoint, params, item);
            } catch (requestError) {
                this.paused = true;
                this.failedCase = item;
                this.error = this.thrownErrorMessage(
                    requestError,
                    item.test_id + ' 요청 중 네트워크 연결이 끊겼습니다.'
                );
                break;
            }
            if (response && response.code === 200 && response.data.result) {
                const result = response.data.result;
                if (
                    !this.isSavedReevaluationMode()
                    && String(result.generator_model || '') !== String(this.selectedGeneratorModel || '')
                ) {
                    this.paused = true;
                    this.failedCase = item;
                    this.error = (
                        item.test_id + ' 응답의 생성 모델(' + String(result.generator_model || '미제공')
                        + ')이 선택한 모델(' + this.selectedGeneratorModel + ')과 다릅니다. '
                        + '평가를 중단했습니다.'
                    );
                    break;
                }
                if (this.isComparisonMode()) {
                    this.comparisonResults.push(result);
                } else {
                    this.results.push(result);
                }
            } else {
                const message = this.errorMessage(
                    response,
                    'SUBJECTIVE 평가 요청에 실패했습니다.'
                );
                if (this.isComparisonMode()) {
                    const local = this.errorResult(
                        item, 'local', this.selectedJudgeModel, message, requestStartedAt
                    );
                    const openai = this.errorResult(
                        item, 'openai', this.openAIConfig().model, message, requestStartedAt
                    );
                    this.comparisonResults.push({
                        comparison_id: item.test_id + '-request-error',
                        test_id: item.test_id,
                        test_type: item.test_type,
                        question_type: 'SUBJECTIVE',
                        category: item.category,
                        question: item.question,
                        gemma_answer: '',
                        ground_truth: '',
                        gold_context_sources: [],
                        source_file: item.source_file,
                        generator_model: this.effectiveGeneratorModel(),
                        local_judge: local,
                        openai_judge: openai,
                        both_scored: false,
                        score_differences: {},
                        score_differences_normalized: {},
                        overall_difference: null,
                        overall_difference_normalized: null
                    });
                } else {
                    const provider = this.selectedJudgeMode === 'OPENAI' ? 'openai' : 'local';
                    const model = provider === 'openai'
                        ? this.openAIConfig().model
                        : this.selectedJudgeModel;
                    this.results.push(
                        this.errorResult(item, provider, model, message, requestStartedAt)
                    );
                }
            }
            this.recalculateSummary();
            await this.service.render();
        }

        this.activeCase = null;
        this.running = false;
        this.runCompletedAt = new Date().toISOString();
        if (this.paused) {
            this.notice = (
                '평가 오류로 일시중지했습니다. 완료된 ' + this.resultCount()
                + '건은 화면에 유지됩니다. 오류 확인 후 중단 지점부터 재개하세요.'
            );
        } else if (this.cancelRequested) {
            this.notice = (
                '평가를 중지했습니다. 완료된 ' + this.resultCount()
                + '건의 부분 결과를 저장합니다.'
            );
        } else {
            this.notice = this.resultCount() + '건의 SUBJECTIVE 평가를 완료했습니다.';
        }
        await this.service.render();
        if (this.resultCount() && !this.paused) await this.saveResults('json', true);
    }

    public async stopEvaluation() {
        if (!this.running) return;
        this.cancelRequested = true;
        this.notice = '현재 문항의 Generator·Judge 응답이 끝난 뒤 중지합니다.';
        await this.service.render();
    }

    public async saveResults(format: string, automatic: boolean = false) {
        if (!this.resultCount() || this.running || this.loadedHistory) return;
        if (!automatic) {
            this.error = '';
            this.notice = '';
        }
        const endpoint = this.selectedJudgeMode === 'LOCAL'
            ? 'save_subjective'
            : (this.selectedJudgeMode === 'OPENAI'
                ? 'save_subjective_openai'
                : 'save_subjective_comparison');
        const payload = this.isComparisonMode()
            ? this.comparisonResults
            : this.results;
        let response: any;
        try {
            response = await wiz.call(endpoint, {
                format: format,
                results: JSON.stringify(payload),
                metadata: JSON.stringify(this.executionMetadata())
            });
        } catch (saveError) {
            this.error = this.thrownErrorMessage(
                saveError,
                '네트워크 오류로 SUBJECTIVE 결과를 저장하지 못했습니다.'
            );
            await this.service.render();
            return;
        }
        if (response && response.code === 200 && response.data.saved) {
            this.savedFiles.unshift(response.data.saved);
            this.notice = format.toUpperCase() + ' SUBJECTIVE 평가 결과를 서버에 저장했습니다.';
            if (!automatic) this.downloadResults(format);
        } else {
            this.error = this.errorMessage(response, 'SUBJECTIVE 결과 파일을 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async selectMergeFiles(event: any) {
        if (this.running || this.mergeRunning) return;
        this.mergeSegments = [];
        this.mergeFiles = [];
        this.mergeError = '';
        this.mergeResult = null;
        this.mergedDocument = null;
        const fileList = event && event.target ? event.target.files : null;
        if (!fileList || !fileList.length) {
            await this.service.render();
            return;
        }
        if (fileList.length > 20) {
            this.mergeError = '한 번에 최대 20개 JSON 파일을 병합할 수 있습니다.';
            await this.service.render();
            return;
        }
        try {
            for (let index = 0; index < fileList.length; index += 1) {
                const file = fileList.item(index);
                const document = JSON.parse(await this.readFileText(file));
                const results = Array.isArray(document)
                    ? document
                    : (document && document.results);
                if (!Array.isArray(results) || !results.length) {
                    throw new Error(file.name + '에 results 배열이 없습니다.');
                }
                const ids = results.map((row: any) => String((row || {}).test_id || ''));
                this.mergeSegments.push({ name: file.name, document: document });
                this.mergeFiles.push({
                    name: file.name,
                    count: results.length,
                    first_test_id: ids[0] || '-',
                    last_test_id: ids[ids.length - 1] || '-'
                });
            }
            if (this.mergeSegments.length < 2) {
                this.mergeError = '앞 구간과 이어서 실행한 구간의 JSON 2개를 선택해주세요.';
            }
        } catch (parseError) {
            this.mergeSegments = [];
            this.mergeFiles = [];
            this.mergeError = this.thrownErrorMessage(
                parseError,
                '선택한 결과 JSON을 읽지 못했습니다.'
            );
        }
        await this.service.render();
    }

    public canMergeOpenAIResults() {
        return !this.running && !this.mergeRunning && this.mergeSegments.length >= 2;
    }

    public async mergeOpenAIResults() {
        if (!this.canMergeOpenAIResults()) return;
        this.mergeRunning = true;
        this.mergeError = '';
        this.notice = '';
        await this.service.render();
        let response: any;
        try {
            response = await wiz.call('merge_subjective_openai', {
                segments: JSON.stringify(this.mergeSegments),
                metadata: JSON.stringify({
                    started_at: '',
                    completed_at: new Date().toISOString(),
                    selected_category: 'ALL',
                    evaluation_scope: 'merged_segments',
                    cancelled: false
                })
            });
        } catch (mergeRequestError) {
            this.mergeError = this.thrownErrorMessage(
                mergeRequestError,
                '네트워크 오류로 OpenAI 결과를 병합하지 못했습니다.'
            );
            this.mergeRunning = false;
            await this.service.render();
            return;
        }
        if (response && response.code === 200 && response.data.saved) {
            this.mergeResult = response.data.merge || {};
            this.mergedDocument = response.data.document || null;
            this.savedFiles.unshift(response.data.saved);
            this.notice = (
                this.mergeResult.merged_result_count
                + '건을 병합해 새 OpenAI 결과 파일로 저장했습니다.'
            );
        } else {
            this.mergeError = this.errorMessage(
                response,
                'OpenAI 결과 파일을 병합하지 못했습니다.'
            );
        }
        this.mergeRunning = false;
        await this.service.render();
    }

    public downloadMergedResults() {
        if (!this.mergedDocument) return;
        const stamp = new Date().toISOString().replace(/[:.]/g, '-');
        const blob = new Blob(
            [JSON.stringify(this.mergedDocument, null, 2)],
            { type: 'application/json;charset=utf-8' }
        );
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'fab-bench-subjective-openai-merged-' + stamp + '.json';
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    }

    public downloadResults(format: string) {
        if (!this.resultCount()) return;
        const stamp = new Date().toISOString().replace(/[:.]/g, '-');
        let body = '';
        let mime = '';
        if (format === 'csv' && this.isComparisonMode()) {
            const fields: string[] = [
                'generator_model', 'execution_server', 'test_id', 'category',
                'local_status', 'openai_status',
                'local_overall', 'openai_overall',
                'local_overall_normalized', 'openai_overall_normalized',
                'overall_difference', 'overall_difference_normalized',
            ];
            for (const metric of this.metrics) {
                fields.push(
                    'local_' + metric.key + '_score',
                    'openai_' + metric.key + '_score',
                    'local_' + metric.key + '_normalized',
                    'openai_' + metric.key + '_normalized',
                    'local_' + metric.key + '_reason',
                    'openai_' + metric.key + '_reason',
                    metric.key + '_difference',
                    metric.key + '_difference_normalized'
                );
            }
            fields.push('input_tokens', 'output_tokens', 'estimated_cost_usd');
            const rows = [fields.join(',')];
            for (const result of this.comparisonResults) {
                const judgeMetrics = (((result.openai_judge || {}).metrics || {}).judge || {});
                const flat: any = {
                    generator_model: result.generator_model || this.effectiveGeneratorModel(),
                    execution_server: JSON.stringify(this.benchmark.execution_server || {}),
                    test_id: result.test_id,
                    category: result.category,
                    local_status: (result.local_judge || {}).status,
                    openai_status: (result.openai_judge || {}).status,
                    local_overall: (result.local_judge || {}).average_score,
                    openai_overall: (result.openai_judge || {}).average_score,
                    local_overall_normalized: (result.local_judge || {}).normalized_score,
                    openai_overall_normalized: (result.openai_judge || {}).normalized_score,
                    overall_difference: result.overall_difference,
                    overall_difference_normalized: result.overall_difference_normalized,
                    input_tokens: judgeMetrics.input_tokens || 0,
                    output_tokens: judgeMetrics.output_tokens || 0,
                    estimated_cost_usd: judgeMetrics.estimated_cost_usd || 0
                };
                for (const metric of this.metrics) {
                    flat['local_' + metric.key + '_score'] = (
                        (result.local_judge || {}).judge_scores || {}
                    )[metric.key];
                    flat['openai_' + metric.key + '_score'] = (
                        (result.openai_judge || {}).judge_scores || {}
                    )[metric.key];
                    flat['local_' + metric.key + '_normalized'] = (
                        (result.local_judge || {}).judge_scores_normalized || {}
                    )[metric.key];
                    flat['openai_' + metric.key + '_normalized'] = (
                        (result.openai_judge || {}).judge_scores_normalized || {}
                    )[metric.key];
                    flat['local_' + metric.key + '_reason'] = (
                        (result.local_judge || {}).judge_reasons || {}
                    )[metric.key];
                    flat['openai_' + metric.key + '_reason'] = (
                        (result.openai_judge || {}).judge_reasons || {}
                    )[metric.key];
                    flat[metric.key + '_difference'] = (result.score_differences || {})[metric.key];
                    flat[metric.key + '_difference_normalized'] = (
                        result.score_differences_normalized || {}
                    )[metric.key];
                }
                rows.push(fields.map((field: string) => this.csvCell(flat[field])).join(','));
            }
            body = '\ufeff' + rows.join('\n');
            mime = 'text/csv;charset=utf-8';
        } else if (format === 'csv') {
            const fields = [
                'generator_model', 'execution_server', 'test_id', 'category',
                'question', 'gemma_answer', 'ground_truth',
                'factuality_score', 'factuality_reason', 'completeness_score',
                'completeness_reason', 'technical_depth_score', 'technical_depth_reason',
                'relevance_score', 'relevance_reason',
                'context_utilization_score', 'context_utilization_reason',
                'support_quality_score', 'support_quality_reason',
                'factuality_normalized', 'completeness_normalized',
                'technical_depth_normalized', 'relevance_normalized',
                'context_utilization_normalized', 'support_quality_normalized',
                'average_score', 'normalized_score', 'status',
                'judge_model', 'judge_execution_mode', 'judge_cpu_fallback_used',
                'judge_cpu_fallback_reason', 'judge_format_retry_count', 'judge_parse_source',
                'judge_parse_repairs', 'judge_api_retry_count', 'judge_api_errors',
                'judge_runner_reset_count', 'response_time_ms', 'error_stage', 'error'
            ];
            const rows = [fields.join(',')];
            for (const result of this.results) {
                const flat: any = Object.assign({}, result);
                flat.generator_model = result.generator_model || this.effectiveGeneratorModel();
                flat.execution_server = JSON.stringify(this.benchmark.execution_server || {});
                for (const metric of this.metrics) {
                    const rawScore = (result.judge_scores || {})[metric.key];
                    flat[metric.key + '_score'] = this.isNumeric(rawScore) ? rawScore : '';
                    const normalizedScore = (result.judge_scores_normalized || {})[metric.key];
                    flat[metric.key + '_normalized'] = this.isNumeric(normalizedScore)
                        ? normalizedScore
                        : '';
                    flat[metric.key + '_reason'] = (result.judge_reasons || {})[metric.key] || '';
                }
                flat.judge_parse_repairs = JSON.stringify(result.judge_parse_repairs || []);
                flat.judge_api_errors = JSON.stringify(result.judge_api_errors || []);
                rows.push(fields.map((field: string) => this.csvCell(flat[field])).join(','));
            }
            body = '\ufeff' + rows.join('\n');
            mime = 'text/csv;charset=utf-8';
        } else {
            body = JSON.stringify({
                schema_version: 1,
                scoring_version: this.currentScoringVersion(),
                run_kind: this.currentRunKind(),
                execution: this.executionMetadata(),
                summary: this.isComparisonMode()
                    ? this.comparisonSummary
                    : this.summary,
                results: this.isComparisonMode()
                    ? this.comparisonResults
                    : this.results
            }, null, 2);
            mime = 'application/json;charset=utf-8';
        }
        const blob = new Blob([body], { type: mime });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'fab-bench-subjective-' + this.selectedJudgeMode.toLowerCase()
            + '-' + stamp + '.' + format;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    }

    public selectResult(result: any) {
        this.selectedResult = this.selectedResult === result ? null : result;
    }

    public filteredResults() {
        if (this.resultFilter === 'ALL') return this.results;
        if (this.resultFilter === 'ERRORS') {
            return this.results.filter((row: any) => row.status !== 'SCORED');
        }
        if (this.resultFilter === 'API_ERRORS') {
            return this.results.filter((row: any) => row.status.indexOf('API_ERROR') >= 0);
        }
        return this.results.filter((row: any) => row.status === this.resultFilter);
    }

    public filteredComparisons() {
        if (this.resultFilter === 'ALL') return this.comparisonResults;
        if (this.resultFilter === 'SCORED') {
            return this.comparisonResults.filter((row: any) => row.both_scored);
        }
        if (this.resultFilter === 'ERRORS') {
            return this.comparisonResults.filter((row: any) => !row.both_scored);
        }
        if (this.resultFilter === 'API_ERRORS') {
            return this.comparisonResults.filter((row: any) => {
                const localStatus = String((row.local_judge || {}).status || '');
                const openaiStatus = String((row.openai_judge || {}).status || '');
                return localStatus.indexOf('API_ERROR') >= 0 || openaiStatus.indexOf('API_ERROR') >= 0;
            });
        }
        return this.comparisonResults.filter((row: any) => {
            return (row.local_judge || {}).status === this.resultFilter
                || (row.openai_judge || {}).status === this.resultFilter;
        });
    }

    public progressPercent() {
        const total = this.runCases().length;
        if (!total) return 0;
        return Math.min(100, Math.round((this.resultCount() / total) * 100));
    }

    public categoryCount(category: string) {
        return (this.benchmark.counts && this.benchmark.counts[category]) || 0;
    }

    public categorySummaryRows() {
        const byCategory = this.summary.by_category || {};
        return ['ROB', 'MULTI', 'GEN'].map((category: string) => Object.assign(
            this.emptyGroupSummary(),
            byCategory[category] || {},
            { category: category }
        ));
    }

    public categoryComparisonRows() {
        const byCategory = this.comparisonSummary.by_category || {};
        return ['ROB', 'MULTI', 'GEN'].map((category: string) => Object.assign(
            this.emptyComparisonGroup(),
            byCategory[category] || {},
            { category: category }
        ));
    }

    public currentRunKind() {
        if (this.loadedHistory) return this.loadedHistory.run_kind;
        if (this.selectedJudgeMode === 'OPENAI') return 'subjective_openai_judge';
        if (this.isComparisonMode()) return 'subjective_judge_comparison';
        return this.runKind;
    }

    public currentScoringVersion() {
        if (this.loadedHistory) return this.loadedHistory.scoring_version;
        if (this.selectedJudgeMode === 'OPENAI') return 'subjective-openai-judge-shared-rubric-v6';
        if (this.isComparisonMode()) return this.benchmark.comparison_scoring_version || 'subjective-judge-comparison-shared-rubric-v6';
        return this.scoringVersion;
    }

    public difference(result: any, metric: string) {
        const value = result && result.score_differences
            ? result.score_differences[metric]
            : null;
        return value === undefined ? null : value;
    }

    public normalizedDifference(result: any, metric: string) {
        const value = result && result.score_differences_normalized
            ? result.score_differences_normalized[metric]
            : null;
        return value === undefined ? null : value;
    }

    public formatDifference(value: any) {
        if (value === null || value === undefined || value === '') return '-';
        const number = Number(value);
        return (number > 0 ? '+' : '') + number.toFixed(2);
    }

    public formatNormalized(value: any) {
        if (!this.isNumeric(value)) return '-';
        return Number(value).toFixed(3);
    }

    public differenceClass(value: any) {
        const number = Number(value || 0);
        if (number > 0) return 'text-emerald-700';
        if (number < 0) return 'text-rose-700';
        return 'text-slate-500';
    }

    public formatCost(value: any) {
        return '$' + Number(value || 0).toFixed(6);
    }

    public score(result: any, metric: string) {
        return result && result.judge_scores ? result.judge_scores[metric] : null;
    }

    public normalizedScore(result: any, metric: string) {
        const stored = result && result.judge_scores_normalized
            ? result.judge_scores_normalized[metric]
            : null;
        if (this.isNumeric(stored)) return Number(stored);
        const raw = this.score(result, metric);
        return this.isNumeric(raw) ? Number(raw) / this.scoreMaximum : null;
    }

    public isNumeric(value: any) {
        return value !== null && value !== undefined && value !== ''
            && Number.isFinite(Number(value));
    }

    public reason(result: any, metric: string) {
        return result && result.judge_reasons ? result.judge_reasons[metric] : '';
    }

    public judgeResponses(result: any) {
        if (result && Array.isArray(result.judge_raw_responses) && result.judge_raw_responses.length) {
            return result.judge_raw_responses;
        }
        return result && (result.judge_raw_response || result.error)
            ? [result.judge_raw_response || result.error]
            : ['-'];
    }

    public scoreClass(score: number) {
        if (score >= this.scoreMaximum * 0.8) return 'bg-emerald-50 text-emerald-700';
        if (score >= this.scoreMaximum * 0.6) return 'bg-amber-50 text-amber-700';
        return 'bg-rose-50 text-rose-700';
    }

    public statusClass(status: string) {
        if (status === 'SCORED') return 'bg-emerald-50 text-emerald-700';
        if (status === 'JUDGE_JSON_ERROR') return 'bg-amber-50 text-amber-700';
        if (status === 'DATA_ERROR') return 'bg-orange-50 text-orange-700';
        return 'bg-rose-50 text-rose-700';
    }

    public formatBytes(value: any) {
        const bytes = Number(value || 0);
        if (!bytes) return '';
        const gb = bytes / (1024 * 1024 * 1024);
        return gb >= 1 ? gb.toFixed(1) + ' GB' : (bytes / (1024 * 1024)).toFixed(0) + ' MB';
    }

    public modelLabel(model: any) {
        const size = model.size ? ' · ' + this.formatBytes(model.size) : '';
        const reason = model.unavailable_reason ? ' (' + model.unavailable_reason + ' · 선택 불가)' : '';
        return model.name + size + reason;
    }

    public judgeModelLabel(model: any) {
        if (model.name === this.effectiveGeneratorModel()) {
            return model.name + ' · 현재 Generator (선택 불가)';
        }
        return this.modelLabel(model);
    }

    public generatorModelLabel(model: any) {
        const specification = [model.parameter_size, model.quantization_level]
            .filter((value: any) => !!value)
            .join(' · ');
        const unavailable = model.available ? '' : ' (현재 Ollama에 없음)';
        return model.label + ' · ' + model.name
            + (specification ? ' · ' + specification : '')
            + unavailable;
    }

    public formatDate(value: string) {
        if (!value) return '-';
        return new Date(value).toLocaleString('ko-KR');
    }

    public trackResult(index: number, result: any) {
        return result.test_id;
    }

    private resetRun() {
        this.metrics = this.metricCatalog.slice();
        this.scoreMaximum = Number(this.benchmark.score_max || 10);
        this.loadedHistory = null;
        this.loadedHistoryDocument = null;
        this.results = [];
        this.comparisonResults = [];
        this.summary = this.emptySummary();
        this.comparisonSummary = this.emptyComparisonSummary();
        this.selectedResult = null;
        this.resultFilter = 'ALL';
        this.savedFiles = [];
        this.runStartedAt = '';
        this.runCompletedAt = '';
        this.evaluationRunId = '';
        this.cancelRequested = false;
        this.activeCase = null;
        this.paused = false;
        this.failedCase = null;
        this.networkRetryCount = 0;
    }

    private hydrateHistoryJudge(row: any) {
        const hydrated: any = Object.assign({}, row || {});
        hydrated.judge_scores = Object.assign({}, hydrated.judge_scores || {});
        hydrated.judge_scores_normalized = Object.assign(
            {},
            hydrated.judge_scores_normalized || {}
        );
        hydrated.judge_reasons = Object.assign({}, hydrated.judge_reasons || {});
        for (const metric of this.metrics) {
            const raw = hydrated.judge_scores[metric.key];
            if (this.isNumeric(raw)
                && !this.isNumeric(hydrated.judge_scores_normalized[metric.key])) {
                hydrated.judge_scores_normalized[metric.key] = Number(raw)
                    / this.scoreMaximum;
            }
        }
        if (this.isNumeric(hydrated.average_score)
            && !this.isNumeric(hydrated.normalized_score)) {
            hydrated.normalized_score = Number(hydrated.average_score)
                / this.scoreMaximum;
        }
        return hydrated;
    }

    private pendingCases() {
        const completed = new Set(
            (this.isComparisonMode()
                ? this.comparisonResults
                : this.results
            ).map((row: any) => row.test_id)
        );
        return this.runCases().filter((item: any) => !completed.has(item.test_id));
    }

    private newEvaluationRunId() {
        return (
            Date.now().toString(36) + '-'
            + Math.random().toString(36).slice(2, 12)
        );
    }

    private requestToken(item: any) {
        return [
            this.evaluationRunId,
            this.selectedJudgeMode.toLowerCase(),
            this.isSavedReevaluationMode()
                ? String(this.selectedSourceRunId || '').replace(/[^A-Za-z0-9._:-]/g, '')
                : String(this.selectedGeneratorModel || '').replace(/[^A-Za-z0-9._:-]/g, ''),
            String(item.test_id || '').replace(/[^A-Za-z0-9._:-]/g, '')
        ].join(':');
    }

    private async callWithNetworkRetry(endpoint: string, params: any, item: any) {
        const retryDelays = [2000, 5000, 10000];
        let lastError: any = null;
        for (let attempt = 0; attempt <= retryDelays.length; attempt += 1) {
            try {
                return await wiz.call(endpoint, params);
            } catch (requestError) {
                lastError = requestError;
                if (attempt >= retryDelays.length) break;
                this.networkRetryCount += 1;
                const delay = retryDelays[attempt];
                this.notice = (
                    item.test_id + ' 네트워크 요청이 끊겼습니다. '
                    + Math.round(delay / 1000) + '초 후 '
                    + (attempt + 1) + '/' + retryDelays.length + ' 재시도합니다.'
                );
                await this.service.render();
                await this.delay(delay);
            }
        }
        throw lastError;
    }

    private delay(milliseconds: number) {
        return new Promise((resolve) => setTimeout(resolve, milliseconds));
    }

    private readFileText(file: any): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ''));
            reader.onerror = () => reject(new Error('파일 읽기에 실패했습니다.'));
            reader.readAsText(file, 'utf-8');
        });
    }

    private thrownErrorMessage(error: any, fallback: string) {
        if (error && error.message) return String(error.message);
        if (error && error.statusText) return String(error.statusText);
        if (error && error.responseJSON && error.responseJSON.data) {
            return error.responseJSON.data.message || fallback;
        }
        return fallback;
    }

    private errorResult(
        item: any,
        provider: string,
        model: string,
        message: string,
        requestStartedAt: number
    ) {
        return {
            test_id: item.test_id,
            test_type: item.test_type,
            question_type: 'SUBJECTIVE',
            category: item.category,
            question: item.question,
            generator_model: this.effectiveGeneratorModel(),
            gemma_answer: '',
            ground_truth: '',
            gold_context_sources: [],
            judge_provider: provider,
            judge_model: model || '',
            judge_execution_mode: 'gpu',
            judge_cpu_fallback_used: false,
            judge_cpu_fallback_reason: '',
            judge_scores: {},
            judge_scores_normalized: {},
            judge_reasons: {},
            average_score: null,
            normalized_score: null,
            status: 'API_ERROR',
            scorable: false,
            generator_raw_response: '',
            judge_raw_response: '',
            judge_raw_responses: [],
            judge_format_retry_count: 0,
            judge_api_retry_count: 0,
            judge_api_errors: [],
            judge_runner_reset_count: 0,
            judge_initial_validation_error: '',
            judge_validation_errors: [],
            judge_parse_source: '',
            judge_parse_repairs: [],
            source_file: item.source_file,
            response_time_ms: Date.now() - requestStartedAt,
            error_stage: 'request',
            error: message,
            metrics: { generator: {}, judge: {} }
        };
    }

    private recalculateSummary() {
        const summarizeRows = (rows: any[]) => {
            const scored = rows.filter((row: any) => row.status === 'SCORED');
            const statuses = rows.map((row: any) => row.status);
            const metricAverages: any = {};
            const metricAveragesNormalized: any = {};
            for (const metric of this.metrics) {
                const values = scored
                    .map((row: any) => Number((row.judge_scores || {})[metric.key]))
                    .filter((value: number) => value >= 0 && value <= this.scoreMaximum);
                metricAverages[metric.key] = values.length
                    ? Number((values.reduce((sum: number, value: number) => sum + value, 0) / values.length).toFixed(2))
                    : 0;
                metricAveragesNormalized[metric.key] = Number(
                    (metricAverages[metric.key] / this.scoreMaximum).toFixed(4)
                );
            }
            const overall = scored
                .map((row: any) => this.metrics.map(
                    (metric: any) => Number((row.judge_scores || {})[metric.key])
                ))
                .filter((values: number[]) => values.every(
                    (value: number) => Number.isFinite(value)
                        && value >= 0 && value <= this.scoreMaximum
                ))
                .map((values: number[]) => (
                    values.reduce((sum: number, value: number) => sum + value, 0)
                    / values.length
                ));
            const overallAverage = overall.length
                ? Number((overall.reduce((sum: number, value: number) => sum + value, 0) / overall.length).toFixed(2))
                : 0;
            const summary: any = {
                total: rows.length,
                scored: scored.length,
                errors: rows.length - scored.length,
                generator_api_error: statuses.filter((status: string) => status === 'GENERATOR_API_ERROR').length,
                generator_response_error: statuses.filter((status: string) => status === 'GENERATOR_RESPONSE_ERROR').length,
                judge_api_error: statuses.filter((status: string) => status === 'JUDGE_API_ERROR').length,
                judge_json_error: statuses.filter((status: string) => status === 'JUDGE_JSON_ERROR').length,
                data_error: statuses.filter((status: string) => status === 'DATA_ERROR').length,
                api_error: statuses.filter((status: string) => status === 'API_ERROR').length,
                metric_averages: metricAverages,
                metric_averages_normalized: metricAveragesNormalized,
                overall_average: overallAverage,
                overall_normalized: Number(
                    (overallAverage / this.scoreMaximum).toFixed(4)
                ),
                score_min: 0,
                score_max: this.scoreMaximum,
                normalization_divisor: this.scoreMaximum
            };
            summary.judge_errors = summary.judge_json_error;
            summary.api_errors = summary.generator_api_error + summary.judge_api_error + summary.api_error;
            summary.overall_score_100 = Number((summary.overall_normalized * 100).toFixed(2));
            return summary;
        };

        const summary: any = summarizeRows(this.results);
        summary.by_category = {};
        for (const category of ['ROB', 'MULTI', 'GEN']) {
            summary.by_category[category] = summarizeRows(
                this.results.filter((row: any) => row.category === category)
            );
        }
        const durations = this.results
            .map((row: any) => Number(row.response_time_ms || 0))
            .filter((value: number) => value > 0);
        summary.average_response_time_ms = durations.length
            ? Number((durations.reduce((sum: number, value: number) => sum + value, 0) / durations.length).toFixed(2))
            : 0;
        summary.openai_usage = {
            api_request_count: 0,
            input_tokens: 0,
            cached_input_tokens: 0,
            output_tokens: 0,
            total_tokens: 0,
            estimated_cost_usd: 0
        };
        for (const row of this.results) {
            const judge = (((row || {}).metrics || {}).judge || {});
            for (const key of [
                'api_request_count', 'input_tokens', 'cached_input_tokens',
                'output_tokens', 'total_tokens'
            ]) summary.openai_usage[key] += Number(judge[key] || 0);
            summary.openai_usage.estimated_cost_usd += Number(judge.estimated_cost_usd || 0);
        }
        summary.openai_usage.estimated_cost_usd = Number(
            summary.openai_usage.estimated_cost_usd.toFixed(8)
        );
        this.summary = summary;

        const summarizeComparisons = (rows: any[]) => {
            const localRows = rows.map((row: any) => row.local_judge || {});
            const openaiRows = rows.map((row: any) => row.openai_judge || {});
            const paired = rows.filter((row: any) => row.both_scored);
            const metricDifferences: any = {};
            const metricDifferencesNormalized: any = {};
            for (const metric of this.metrics) {
                const values = paired
                    .map((row: any) => Number((row.score_differences || {})[metric.key]))
                    .filter((value: number) => Number.isFinite(value));
                metricDifferences[metric.key] = values.length
                    ? Number((values.reduce((sum: number, value: number) => sum + value, 0) / values.length).toFixed(2))
                    : 0;
                metricDifferencesNormalized[metric.key] = Number(
                    (metricDifferences[metric.key] / this.scoreMaximum).toFixed(4)
                );
            }
            const overallValues = paired
                .map((row: any) => Number(row.overall_difference))
                .filter((value: number) => Number.isFinite(value));
            const usage: any = {
                api_request_count: 0,
                input_tokens: 0,
                cached_input_tokens: 0,
                output_tokens: 0,
                total_tokens: 0,
                estimated_cost_usd: 0
            };
            for (const row of openaiRows) {
                const judge = (((row || {}).metrics || {}).judge || {});
                for (const key of [
                    'api_request_count', 'input_tokens', 'cached_input_tokens',
                    'output_tokens', 'total_tokens'
                ]) usage[key] += Number(judge[key] || 0);
                usage.estimated_cost_usd += Number(judge.estimated_cost_usd || 0);
            }
            usage.estimated_cost_usd = Number(usage.estimated_cost_usd.toFixed(8));
            const overallDifference = overallValues.length
                ? Number((overallValues.reduce((sum: number, value: number) => sum + value, 0) / overallValues.length).toFixed(2))
                : 0;
            return {
                total: rows.length,
                paired_scored: paired.length,
                local: summarizeRows(localRows),
                openai: summarizeRows(openaiRows),
                metric_differences: metricDifferences,
                metric_differences_normalized: metricDifferencesNormalized,
                overall_difference: overallDifference,
                overall_difference_normalized: Number(
                    (overallDifference / this.scoreMaximum).toFixed(4)
                ),
                openai_usage: usage
            };
        };
        const comparisonSummary: any = summarizeComparisons(this.comparisonResults);
        comparisonSummary.by_category = {};
        for (const category of ['ROB', 'MULTI', 'GEN']) {
            comparisonSummary.by_category[category] = summarizeComparisons(
                this.comparisonResults.filter((row: any) => row.category === category)
            );
        }
        this.comparisonSummary = comparisonSummary;
    }

    private emptyMetricValues() {
        const values: any = {};
        for (const metric of this.metrics) values[metric.key] = 0;
        return values;
    }

    private emptyGroupSummary() {
        return {
            total: 0,
            scored: 0,
            errors: 0,
            generator_api_error: 0,
            generator_response_error: 0,
            judge_api_error: 0,
            judge_json_error: 0,
            data_error: 0,
            api_error: 0,
            judge_errors: 0,
            api_errors: 0,
            metric_averages: this.emptyMetricValues(),
            metric_averages_normalized: this.emptyMetricValues(),
            overall_average: 0,
            overall_normalized: 0,
            score_min: 0,
            score_max: this.scoreMaximum,
            normalization_divisor: this.scoreMaximum,
            overall_score_100: 0
        };
    }

    private emptySummary() {
        const summary: any = this.emptyGroupSummary();
        summary.average_response_time_ms = 0;
        summary.openai_usage = {
            api_request_count: 0,
            input_tokens: 0,
            cached_input_tokens: 0,
            output_tokens: 0,
            total_tokens: 0,
            estimated_cost_usd: 0
        };
        summary.by_category = {
            ROB: this.emptyGroupSummary(),
            MULTI: this.emptyGroupSummary(),
            GEN: this.emptyGroupSummary()
        };
        return summary;
    }

    private emptyComparisonGroup() {
        return {
            total: 0,
            paired_scored: 0,
            local: this.emptyGroupSummary(),
            openai: this.emptyGroupSummary(),
            metric_differences: this.emptyMetricValues(),
            metric_differences_normalized: this.emptyMetricValues(),
            overall_difference: 0,
            overall_difference_normalized: 0,
            openai_usage: {
                api_request_count: 0,
                input_tokens: 0,
                cached_input_tokens: 0,
                output_tokens: 0,
                total_tokens: 0,
                estimated_cost_usd: 0
            }
        };
    }

    private emptyComparisonSummary() {
        const summary: any = this.emptyComparisonGroup();
        summary.by_category = {
            ROB: this.emptyComparisonGroup(),
            MULTI: this.emptyComparisonGroup(),
            GEN: this.emptyComparisonGroup()
        };
        return summary;
    }

    private executionMetadata() {
        return {
            generator_model: this.effectiveGeneratorModel(),
            execution_server: this.benchmark.execution_server || {},
            judge_model: this.selectedJudgeModel,
            judge_mode: this.selectedJudgeMode,
            local_judge_model: this.selectedJudgeModel,
            openai_judge_model: this.openAIConfig().model || '',
            generator_temperature: 0,
            judge_temperature: 0,
            judge_json_max_retries: this.benchmark.judge_json_max_retries || 3,
            problem_count: this.resultCount(),
            started_at: this.runStartedAt,
            completed_at: this.runCompletedAt || new Date().toISOString(),
            evaluation_run_id: this.evaluationRunId,
            network_retry_count: this.networkRetryCount,
            resume_after_test_id: this.resumeAfterTestId,
            selected_category: this.selectedCategory,
            evaluation_scope: this.evaluationScope === 'TEST_5' ? 'test_5' : 'full',
            cancelled: this.cancelRequested,
            rag_enabled: false,
            external_api_enabled: this.usesOpenAIJudge(),
            source_run_id: this.isSavedReevaluationMode() ? this.selectedSourceRunId : '',
            source_input_sha256: this.isSavedReevaluationMode()
                ? (this.sourceRun().source_input_sha256 || '')
                : '',
            rubric_version: this.benchmark.rubric_version || '',
            rubric_prompt_sha256: this.benchmark.rubric_prompt_sha256 || '',
            score_min: 0,
            score_max: this.scoreMaximum,
            normalization_divisor: this.scoreMaximum,
            normalized_min: 0,
            normalized_max: 1,
            reused_generator_answers: this.isSavedReevaluationMode(),
            structured_output: this.usesOpenAIJudge(),
            store: false,
            stream: false
        };
    }

    private csvCell(value: any) {
        const text = String(value === undefined || value === null ? '' : value);
        return '"' + text.replace(/"/g, '""') + '"';
    }

    private errorMessage(response: any, fallback: string) {
        if (response && response.data && response.data.message) return response.data.message;
        if (response && response.responseJSON && response.responseJSON.data) {
            return response.responseJSON.data.message || fallback;
        }
        return fallback;
    }
}

export default PageFabbenchComponent;